import React, { useState, useEffect } from "react";
import Admin from "./Admin";
import "../../styles/admin.css";
import { AdminStatCard } from "../../components/AdminStatCard";

export default function AdminDashboard({ addToast }) {
  const [stats, setStats] = useState([]);

  useEffect(() => {
    // FONTOS: pontos URL
    fetch("https://focifanatik.hu/api/admin_dashboard_stats.php")
      .then((response) => response.json())
      .then((data) => {
        console.log("Kapott adatok:", data); // ← ezzel látod a böngésző konzolban, hogy tényleg jön adat
        setStats(data);
      })
      .catch((err) => console.error("Hiba a lekéréskor:", err));
  }, []);

  return (
    <div className="admin-page">
      <Admin />

      <main className="admin-content">
        <header className="admin-header">
          <h3>📊 Admin irányítópult</h3>
          <span className="admin-subtitle">Áttekintés és statisztikák</span>
        </header>

        <section className="admin-main">

          {/* ===== GYORS STAT ===== */}
          {/* <h5 className="section-title">Gyors áttekintés</h5>
          <div className="dashboard-grid">
            <AdminStatCard title="Felhasználók" value={stats.total_users} icon="people-fill" color="blue" />
            <AdminStatCard title="Aktív felhasználók" value={stats.active_users} icon="activity" color="green" />
            <AdminStatCard title="Mai szavazatok" value={stats.total_votes} icon="check2-square" color="teal" />
            <AdminStatCard title="Aktív meccsek" value={stats.active_matches} icon="trophy-fill" color="yellow" />
          </div> */}

          {/* ===== FELHASZÁLÓI STATISZTIKÁK ===== */}
          <h5 className="section-title mt-4">Felhasználói statisztikák</h5>
          <div className="dashboard-grid">
            <AdminStatCard title="Regisztrált felhasználók" value={stats.total_registered_users} icon="person" color="green" />
            <AdminStatCard title="Összes adminok" value={stats.total_admins} icon="person-circle" color="red" />
            <AdminStatCard title="Felhasználók email értesitéssel" value={stats.total_email_notifications_enabled_user} icon="envelope" color="blue" />
          </div>

          {/* ===== FELHASZNÁLÓI STATISZTIKÁK ELMÚLT 24 ÓRÁBAN ===== */}
          <h5 className="section-title mt-4">Felhasználói statisztikák az ELMÚLT 24 órában</h5>
          <div className="dashboard-grid">
            <AdminStatCard title="Regisztrált felhasználók az elmúlt 24 órában" value={stats.total_registered_users_last_24h} icon="graph-up-arrow" color="green" />
            <AdminStatCard title="Aktiv felhasználók az elmúlt 24 órában" value={stats.total_active_users_last_24h} icon="check2" color="red" />
            <AdminStatCard title="Bejelentkezett felhasználók az elmúlt 24 órában" value={stats.total_logged_in_users_last_24h} icon="unlock" color="blue" />
          </div>

          {/* ===== FELHASZNÁLÓI STATISZTIKÁK ELMÚLT 7 NAP ===== */}
          <h5 className="section-title mt-4">Felhasználói statisztikák az ELMÚLT 7 napban</h5>
          <div className="dashboard-grid">
            <AdminStatCard title="Regisztrált felhasználók az elmúlt 7 napban" value={stats.total_registered_users_last_7day} icon="graph-up-arrow" color="green" />
            <AdminStatCard title="Aktiv felhasználók az elmúlt 7 napban" value={stats.total_active_users_last_7day} icon="check2" color="red" />
            <AdminStatCard title="Bejelentkezett felhasználók az elmúlt 7 napban" value={stats.total_logged_in_users_last_7day} icon="unlock" color="blue" />
          </div>

          {/* ===== FELHASZNÁLÓI STATISZTIKÁK ELMÚLT 30 NAP ===== */}
          <h5 className="section-title mt-4">Felhasználói statisztikák az ELMÚLT 30 napban</h5>
          <div className="dashboard-grid">
            <AdminStatCard title="Regisztrált felhasználók az elmúlt 30 napban" value={stats.total_registered_users_last_30day} icon="graph-up-arrow" color="green" />
            <AdminStatCard title="Aktiv felhasználók az elmúlt 30 napban" value={stats.total_active_users_last_30day} icon="check2" color="red" />
            <AdminStatCard title="Bejelentkezett felhasználók az elmúlt 30 napban" value={stats.total_logged_in_users_last_30day} icon="unlock" color="blue" />
          </div>

          {/* ===== INAKTIV FELHASZNÁLÓK ===== */}
          <h5 className="section-title mt-4">Inaktiv felhasználók</h5>
          <div className="dashboard-grid">
            <AdminStatCard title="48 Órája inaktiv felhasználók" value={stats.total_inactive_users_last_48h} icon="person-fill-dash" color="blue" />
            <AdminStatCard title="7 napja inaktiv felhasználók" value={stats.total_inactive_users_last_7day} icon="person-fill-dash" color="red" />
            <AdminStatCard title="30 Napja inaktiv felhasználók" value={stats.total_inactive_users_last_30day} icon="person-fill-dash" color="green" />
          </div>



          {/* ===== TIPPELÉS ===== */}
          <h5 className="section-title mt-4">Tippelési statisztikák</h5>
          <div className="dashboard-grid">
            <AdminStatCard title="Összes tippek ALL TIME" value={stats.total_votes_alltime} icon="suit-club" color="green" />
            <AdminStatCard title="Összes tippek az elmúlt egy hétben" value={stats.total_votes_last_7day} icon="suit-club" color="green" />
            <AdminStatCard title="Átlag tipp/mérkőzés" value={stats.average_tips_per_match} icon="suit-club" color="green" />
            <AdminStatCard title="Tippelés csúcsidő" value={stats.peak_voting_hour} icon="suit-club" color="green" />
          </div>

          {/* ===== KOMMENT STATISZTIKÁK ===== */}
          <h5 className="section-title mt-4">Komment statisztikák az ELMÚLT 7 napban</h5>
          <div className="dashboard-grid">
            <AdminStatCard title="Kommentek száma az elmúlt 7 napban" value={stats.total_comments_last_7day} icon="fonts" color="green" />
          </div>

          {/* ===== STRATÉGIA STATISZTIKÁK ===== */}
          <h5 className="section-title mt-4">Stratégia statisztikák az ELMÚLT 7 napban</h5>
          <div className="dashboard-grid">
            <AdminStatCard title="Létrehozott stratégiák az elmúlt 7 napban" value={stats.total_strategies_created_last_7day} icon="book" color="green" />
          </div>

          {/* ===== JEGYZET STATISZTIKÁK ===== */}
          <h5 className="section-title mt-4">Jegyzet statisztikák az ELMÚLT 7 napban</h5>
          <div className="dashboard-grid">
            <AdminStatCard title="Létrehozott jegyzetek az elmúlt 7 napban" value={stats.total_notes_created_last_7day} icon="card-list" color="green" />
          </div>

        </section>
      </main>
    </div>
  );

}
